const mode = process.env.REACT_APP_MODE || "LOCAL";


const API = {
  BASE_URL: "",
  PAYMENT_BASE_URL: "",
  
  BOOK_SLOT: "submit.php",
  GET_SLOT: "list.php",
  UPDATE_SLOT: "updateData.php",
  UPDATE_ORDER_ID: "updateOrderId.php",


  KEY: "rzp_live_PHD5tJ258iR0HC",
  PAYMENT: "payment",
  TICKET_SUCCESS: "ticketSuccess",
  PAYMENT_CLOSED: "paymentClosed"
};


// Base URL
if (mode === "LOCAL") {
  API["BASE_URL"] = "https://devarus.aftergen.in/dev/API/oneAppWorkspace/surgeCollege/";
}
if (mode === "DEV") {
  API["BASE_URL"] = "https://devarus.aftergen.in/dev/API/oneAppWorkspace/surgeCollege/";
}
if (mode === "LIVE") {
  API["BASE_URL"] = "https://api.pepul.com/surgeCollege/";
}

// Payment Base URL
if (mode === "LOCAL") {
  API["PAYMENT_BASE_URL"] = "https://pricedev.hifrds.com/api/v1/workfast/";
}
if (mode === "DEV") {
  API["PAYMENT_BASE_URL"] = "https://pricedev.hifrds.com/api/v1/workfast/";
}
if (mode === "LIVE") {
  API["PAYMENT_BASE_URL"] = "https://pricelive.hifrds.com/api/v1/workfast/";
}

export default API;
